// External Plugins

// App components
import './components/fixedHeader';
import './components/offCanvasNav';
import './components/cookieConsent';
import smoothscroll from 'smoothscroll-polyfill';

// import './components/serviceWorkerInit';
// import './components/fontTrackingCode';
import { initLightboxGallery } from './components/lightboxGallery';

// IE11 polyfill for external svgs
import svg4everybody from 'svg4everybody';

(function() {
	const bindEvents = () => {
		// Remove Iframe and Video loader when ready
		document.addEventListener('lazyloaded', e => {
			const closestHasLoaderParent = e.target.closest('.has-loader');

			if (closestHasLoaderParent) {
				closestHasLoaderParent.classList.remove('has-loader');
			}
		});
	};

	const init = () => {
		bindEvents();

		svg4everybody();

		// Init Photoswipe
		if (document.querySelectorAll('.gallery').length) {
			initLightboxGallery('.gallery');
		}
		if (document.querySelectorAll('figure.wp-caption').length) {
			initLightboxGallery('figure.wp-caption');
		}

		// Scroll into view
		smoothscroll.polyfill();
		const items = Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]'));
		items.forEach(anchor => {
			anchor.addEventListener('click', function(e) {
				e.preventDefault();
				const href = anchor.getAttribute('href');
				if (href !== '#' && document.querySelector(href)) {
					document.querySelector(href).scrollIntoView({ behavior: 'smooth' });
				}
			});
		});
	};

	document.addEventListener('DOMContentLoaded', init);
})();
